/**
 * The `<svg>` carries the className. An unresolvable attribute renders no
 * element at all, but that is a data error rather than a different root type,
 * so the configured happy path is what this answers for.
 */
export const resolveRendersOwnElement = (): boolean => true;
